import type { DocPageContent } from '../docs-content'

const page = {
  order: 2,
  slug: 'workspaces',
  title: '工作区与存储',
  description: '工作区文件夹、权限、本地文件和项目存储。',
  category: '开始',
  sections: [
    {
      title: '工作区模式',
      items: [
        '工作区是剪见 JIAN 可以读取和写入的文件夹。',
        '项目数据、生成的素材、转录稿、场景切割、缓存和导出文件都存放在其中。',
        '导入的本地媒体保持磁盘链接，除非被打包到项目包中。',
      ],
    },
    {
      title: '权限',
      items: [
        '浏览器可能要求剪见 JIAN 在会话之间重新连接到工作区。',
        '使用"重新连接"授权访问同一文件夹。',
        '当工作区已移动或不再存在时，选择"选择其他文件夹"。',
      ],
    },
    {
      title: '维护',
      items: [
        '从工作区控件中切换、添加或移除已知工作区。',
        '清除缓存数据而不删除源媒体。',
        '当项目需要随其媒体文件一起移动时，使用项目包。',
      ],
    },
  ],
} satisfies DocPageContent

export default page
